<app-upload
  [allowedMimeTypes]="allowedMimeTypes()"
  [disabled]="disabled()"
  [maxFileSize]="maxFileSize()"
  [maxNumberOfFiles]="maxNumberOfFiles()"
  [multi]="multi()"
  [uploadFn]="uploadFn" />

<div class="mt-3">
  <app-multimedia-grid-layout
    templateColumns="sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-3 2xl:grid-cols-4">
    @for (item of uploadQueue(); track item.name) {
      <app-multimedia-grid-layout-item>
        <app-multimedia-tile mode="loading" />
      </app-multimedia-grid-layout-item>
    }

    @for (id of uploaded(); track id) {
      @if (id | publicShopFileThumbnailUrl: Large; as url) {
        <app-multimedia-grid-layout-item>
          <app-multimedia-tile-thumbnail
            [withClickEvent]="false"
            [withRemoveEvent]="true"
            (removeClickEvent)="handleRemoveClickEvent(id)"
            [alt]="chosenId()!"
            [url]="url"
            filling="contain" />
        </app-multimedia-grid-layout-item>
      } @else {
        <app-multimedia-grid-layout-item>
          <app-multimedia-tile mode="loading" />
        </app-multimedia-grid-layout-item>
      }
    }
  </app-multimedia-grid-layout>
</div>
